/* tslint:disable */

import { ReaderFragment } from "relay-runtime";
import { FragmentRefs } from "relay-runtime";
export type PdpRespSimilarItemsGridSeller_viewer = {
    readonly " $fragmentRefs": FragmentRefs<"PdpRespSimilarItem_viewer">;
    readonly " $refType": "PdpRespSimilarItemsGridSeller_viewer";
};
export type PdpRespSimilarItemsGridSeller_viewer$data = PdpRespSimilarItemsGridSeller_viewer;
export type PdpRespSimilarItemsGridSeller_viewer$key = {
    readonly " $data"?: PdpRespSimilarItemsGridSeller_viewer$data;
    readonly " $fragmentRefs": FragmentRefs<"PdpRespSimilarItemsGridSeller_viewer">;
};



const node: ReaderFragment = {
  "kind": "Fragment",
  "name": "PdpRespSimilarItemsGridSeller_viewer",
  "type": "Viewer",
  "metadata": null,
  "argumentDefinitions": [],
  "selections": [
    {
      "kind": "FragmentSpread",
      "name": "PdpRespSimilarItem_viewer",
      "args": null
    }
  ]
};
(node as any).hash = 'b2ac9e95e218aa71d2752773c7d8b309';
export default node;
